import { PERIODS, TIERS } from "constants/pricing";
export const ADDONS = {
    VIBE: "vibe"
};
const VIBE_PRICE_PER_UNIT_BASE = {
    usd: 10,
    euro: 10,
    gbp: 9,
    cad: 14,
    aud: 16,
    mxn: 200,
    brl: 55,
    inr: 750,
    jpy: 1375,
    ils: 36
};
const VIBE_PRICE_PER_UNIT = {
    [PERIODS.monthly]: VIBE_PRICE_PER_UNIT_BASE,
    [PERIODS.yearly]: VIBE_PRICE_PER_UNIT_BASE
};
export const ADDON_CONFIG = {
    [ADDONS.VIBE]: {
        pricePerUnit: VIBE_PRICE_PER_UNIT,
        defaultUnit: 10,
        displayName: "Vibe",
        unitOptions: [
            {
                value: 0,
                labelKey: "pricingPage.addons.vibe.options.draftOnly"
            },
            {
                value: 10,
                labelKey: "pricingPage.addons.vibe.options.10apps"
            },
            {
                value: 25,
                labelKey: "pricingPage.addons.vibe.options.25apps"
            }
        ],
        bannerTextKey: "pricingPage.addons.vibe.bannerText",
        featureTextKey: "pricingPage.addons.vibe.featureText",
        /** Tiers where this addon is not shown (no feature row, no addon in price). Omit or empty = available on all tiers. */ excludedTiers: [
            TIERS.FREE
        ]
    }
};
/**
 * Returns whether the addon should be shown for the given tier (feature row + addon in price).
 * Uses ADDON_CONFIG[addon].excludedTiers; when excludedTiers is missing or empty, addon is available on all tiers.
 */ export const isAddonAvailableForTier = (addon, tierName)=>{
    const config = ADDON_CONFIG[addon];
    if (!config) return false;
    const excluded = config.excludedTiers;
    if (!excluded || excluded.length === 0) return true;
    return !excluded.includes(tierName);
};
